// A UI-only synchronous lock. Backend idempotency/authorization remain unchanged.
export function createSubmissionGate(change: (busy: boolean) => void) {
  let locked = false;
  return async <T,>(operation: () => Promise<T>): Promise<T | undefined> => {
    if (locked) return;
    locked = true; change(true);
    try { return await operation(); }
    finally { locked = false; change(false); }
  };
}
